import React, { createContext, useContext } from 'react';

export const FilterContext = createContext({
  enabled: false,
});

export const FilterRenderer = ({ tabIndex, column, children }) => {
  const filters = useContext(FilterContext);
  return (
    <>
      <div>{column.name}</div>
      {filters.enabled && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {children({ tabIndex, filters })}
        </div>
      )}
    </>
  );
};

export const rowKeyGetter = (row) => {
  return row.id;
};

export const autoFocusAndSelect = (input) => {
  input?.focus();
  input?.select();
}

export const inputStopPropagation = (event) => {
  if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.stopPropagation();
  }
};

export const selectStopPropagation = (event) => {
  if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
    event.stopPropagation();
  }
};

export const handleCopy = ({ sourceRow, sourceColumnKey }) => {
  if (window.isSecureContext) {
    navigator.clipboard.writeText(sourceRow[sourceColumnKey]);
  }
};

export const renderTextEditor = ({ row, column, onRowChange, onClose }) => {
  return (
    <input
      className="rdg-text-editor"
      autoFocus
      value={row[column.key] ?? ''}
      onChange={(event) => {
        onRowChange({
          ...row,
          [column.key]: event.target.value,
        });
      }}
      onBlur={() => onClose(true)}
    />
  );
};

// react-data-grid passes the currently visible (filtered/sorted) rows to the
// row-change handler. Never replace the full backing state with that subset.
// Merge the edited visible rows back by id so clearing a search restores every
// hidden row, matching the General Ledger table behaviour.
export const mergeEditedGridRows = (
  currentRows = [],
  visibleRows = [],
  targetRowIds = [],
  fallbackUpdates = {},
) => {
  const visibleById = new Map(
    (visibleRows || []).map((row) => [row.id, row]),
  );
  const targetIds = new Set(targetRowIds || []);

  return (currentRows || []).map((row) => {
    const visibleRow = visibleById.get(row.id);
    if (visibleRow) return visibleRow;
    if (targetIds.has(row.id)) return { ...row, ...fallbackUpdates };
    return row;
  });
};

